<script>
  /* Executable code section of the program */
  // Tools importation
  import * as XLSX from "xlsx";
  import { excelAttendeeData, updateDataExcel } from "../apis/storage";
  import {
    documentExists,
    getOneDocument,
    getSpecificDocuments,
  } from "../apis/APIS";

  let file; // Stores the selected file
  let excelData = []; // Will save the read data
  let arrKeys = [];
  let arrayTemporal = []
  $: dinamicArray = [];

  // Función para leer el archivo Excel
  function handleFile(event) {
    arrKeys = [];
    const file = event.target.files[0]; // get the file
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0]; // Get tht firts sheet
      const sheet = workbook.Sheets[sheetName];

      // Convertir a JSON
      excelData = XLSX.utils.sheet_to_json(sheet);

      arrKeys = Object.keys(excelData[0]).map((key) => key.toLocaleLowerCase()); // Get the keys for each object

      excelData.forEach(async (data) => {
        let currentEvent = await getSpecificDocuments(
          "events",
          "tittle",
          data.Event
        );

        let dataObj = {};
        dataObj[arrKeys[0]] = data.Name;
        dataObj[arrKeys[1]] = data.Surname;
        dataObj[arrKeys[2]] = data.Country;
        dataObj[arrKeys[3]] = data.Jobtittle;
        dataObj[arrKeys[4]] = data.Company;
        dataObj[arrKeys[5]] = data.Event;
        dataObj[arrKeys[6]] = data.Email;
        dataObj[arrKeys[7]] = data.Password;
        dataObj.availableMeet = true;
        dataObj.profileImgUrl = "";
        dataObj.pastEvents = [];
        dataObj.eventList = [data.Event];
        dataObj.scheduledMeetings = [];
        if (currentEvent.length > 0) {
          dataObj.myChats = [
            {
              chatId: currentEvent[0].tittle,
              eventCountry: currentEvent[0].country,
              eventPoster: currentEvent[0].eventMultimedia.eventImgUrl,
              eventTittle: currentEvent[0].tittle,
            },
          ];
        } else {
          dataObj.myChats = [
            {
              chatId: data.Event,
              eventCountry: "",
              eventPoster: "",
              eventTittle: data.Event,
            },
          ];
        }

        dataObj.answeredPolls = [];
        dataObj.customButtons = [];
        dataObj.customBreaks = [];
        dataObj.customTables = [];
        dataObj.userRole = "attendee";
        documentExists("users", "email", data.Email).then(async (exists) => {
          if (!exists) {
            $excelAttendeeData.push(dataObj);
            dinamicArray = $excelAttendeeData;
          } else {
            let currentUser = await getSpecificDocuments(
              "users",
              "email",
              data.Email
            );

            if (currentUser[0].event !== data.Event) {
              $updateDataExcel.push({
                id: currentUser[0].id,
                fields: {
                  event: data.Event,
                  eventList: [data.Event],
                  answeredPolls: [],
                  customButtons: [],
                  customBreaks: [],
                  customTables: [],
                  myChats:
                    currentEvent.length > 0
                      ? [...currentUser[0].myChats,{
                          chatId: currentEvent[0].tittle,
                          eventCountry: currentEvent[0].country,
                          eventPoster:
                            currentEvent[0].eventMultimedia.eventImgUrl,
                          eventTittle: currentEvent[0].tittle,
                        }]
                      : [...currentUser[0].myChats,{
                          chatId: data.Event,
                          eventCountry: "",
                          eventPoster: "",
                          eventTittle: data.Event,
                        }],
                },
              });
              arrayTemporal.push(dataObj)
              
              dinamicArray = [...$excelAttendeeData,...arrayTemporal];
            }
          }
        });
      });
    };
    reader.readAsArrayBuffer(file);
  }
  /* End of the section */
</script>

<!-- Section to place the HTML code -->

{#if dinamicArray.length > 0}
  <h2>Uploaded data</h2>
  <table class="table table-striped">
    <thead>
      <tr class="fila">
        <th>#</th>
        {#each Object.keys(excelData[0]) as key}
          <th scope="col">{key}</th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each dinamicArray as data, index}
        <tr class="fila">
          <th scope="row">{index + 1}</th>
          <td>{data.name}</td>
          <td>{data.surname}</td>
          <td>{data.country}</td>
          <td>{data.jobtittle}</td>
          <td>{data.company}</td>
          <td>{data.event}</td>
          <td>{data.email}</td>
          <td>{data.password}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{:else}
  <h2>Upload Files</h2>
  <div class="imgContainer">
    <div class="updateImageContainer">
      <label for="image" class="editBtnContainer">
        <input
          type="file"
          id="image"
          name="image"
          style="display: none;"
          accept=".xlsx, .xls"
          on:change={handleFile}
        />
        <span class="btnInput">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            fill="currentColor"
            class="bi bi-filetype-exe"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM2.575 15.202H.785v-1.073H2.47v-.606H.785v-1.025h1.79v-.648H0v3.999h2.575zM6.31 11.85h-.893l-.823 1.439h-.036l-.832-1.439h-.931l1.227 1.983-1.239 2.016h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992zm1.025 3.352h1.79v.647H6.548V11.85h2.576v.648h-1.79v1.025h1.684v.606H7.334v1.073Z"
            />
          </svg>
        </span>
        Upload Excel file with the list of attendees
      </label>
    </div>
  </div>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  h2 {
    padding: 15px 0;
    border-bottom: 1px solid gray;
  }
  .imgContainer {
    background-color: #f4f4f4;
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
  }
  .updateImageContainer {
    width: 50%;
    height: 100%;
    border-radius: 20px;
    background-color: white;
    z-index: 888;
  }
  .updateImageContainer:hover {
    opacity: 1;
    cursor: pointer;
  }
  .editBtnContainer {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.514);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .imgContainer {
      background-color: #f4f4f4;
      width: 100%;
      height: 50vh;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
    }
    .updateImageContainer {
      width: 80%;
      height: 80%;
      border-radius: 20px;
      background-color: white;
      z-index: 888;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .updateImageContainer {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background-color: white;
      z-index: 888;
    }
  }

  /* End of the section */
</style>
